import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const Page = styled.div`
  width: 90%;
  max-width: ${screenSizes.desktop};
  margin: 0 auto;
  padding: 1.5rem 1rem 2.5rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  border: 1px solid #e9ecef;

  @media only screen and (max-width: ${screenSizes.tablet}) {
    width: 100%;
    padding: 1.25rem 1rem 2rem;
    border-radius: 12px;
  }

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.85rem 0.75rem 1.25rem;
    border-radius: 10px;
  }

  .selectGroup.ui.segment {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
`;

export const StepCard = styled.div`
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;
  padding: 0;
  text-align: left;

  .flow-back.ui.button {
    background: #f1f3f5 !important;
    color: #444 !important;
    border-radius: 999px !important;
    font-weight: 600 !important;
    margin: 0 0 1.25rem !important;
    box-shadow: none !important;
    padding: 0.65rem 1.1rem !important;
  }

  .form-section {
    margin-bottom: 1.5rem;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      margin-bottom: 0.9rem;
    }
  }

  .form-errors {
    color: #db2828;
    font-size: 0.9rem;
    text-align: center;
    margin: 0 0 1rem;
    padding: 0.65rem 1rem;
    background: #fff6f6;
    border-radius: 8px;
    border: 1px solid #e0b4b4;
  }

  .submit-actions {
    text-align: center;
    padding-top: 0.5rem;

    .ui.button.primary {
      width: 100%;
      max-width: 100%;
      font-size: 1rem;
      font-weight: 700;
      padding: 1rem 2rem;
      border-radius: 999px;
      background: #1a1a1a !important;
      color: #fff !important;

      &:hover {
        background: #333 !important;
      }
    }
  }
`;

export const StepProgressBar = styled.div`
  margin-bottom: 1.5rem;

  @media only screen and (max-width: ${screenSizes.mobile}) {
    margin-bottom: 1rem;
  }

  .step-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.65rem;
    gap: 0.75rem;
  }

  .step-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #1a1a1a;
  }

  .step-count {
    font-size: 0.78rem;
    color: #888;
    white-space: nowrap;
  }

  .step-bars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.4rem;
  }

  .step-bar {
    height: 4px;
    border-radius: 999px;
    background: #e8edf2;
    transition: background 0.2s ease;

    &.active {
      background: #7ec8e8;
    }

    &.current {
      background: #4db8e8;
    }
  }
`;

export const FlowHeader = styled.div`
  margin-bottom: 1.25rem;

  @media only screen and (max-width: ${screenSizes.mobile}) {
    margin-bottom: 0.85rem;
  }

  h1 {
    color: #1a1a1a;
    font-size: 1.65rem;
    font-weight: 700;
    margin: 0 0 0.65rem;
    line-height: 1.25;
    text-align: left;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 1.3rem;
      margin-bottom: 0.4rem;
      line-height: 1.2;
    }
  }

  .flow-intro {
    color: #666;
    font-size: 0.92rem;
    line-height: 1.55;
    margin: 0;
    text-align: left;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 0.82rem;
      line-height: 1.4;
    }
  }

  .focus-box {
    margin-top: 1.25rem;
    padding: 1rem 1.1rem;
    background: #f3f9fc;
    border: 1px solid #d8ecf5;
    border-radius: 12px;

    .focus-label {
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #7a8a96;
      margin: 0 0 0.45rem;
    }

    .focus-question {
      font-size: 0.95rem;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0;
      line-height: 1.45;
    }
  }
`;

export const CalculatedAgePill = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  padding: 0.85rem 1.1rem;
  margin-bottom: 1.5rem;
  background: #e8f6fc;
  border: 1px solid #c5e8f5;
  border-radius: 14px;

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.7rem 0.85rem;
    margin-bottom: 0.9rem;
    gap: 0.5rem 0.75rem;
    border-radius: 10px;
  }

  .age-label {
    font-weight: 700;
    font-size: 0.88rem;
    color: #1a1a1a;
    line-height: 1.3;
    flex-shrink: 0;
  }

  .age-value {
    display: inline-flex;
    align-items: center;
    padding: 0.45rem 0.95rem;
    background: #fff;
    border-radius: 999px;
    font-weight: 700;
    font-size: 0.88rem;
    color: #1a1a1a;
    line-height: 1.35;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 0.8rem;
      padding: 0.4rem 0.8rem;
    }
  }
`;

export const FormCard = styled.form`
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;
  padding: 0.5rem 0.25rem;
  text-align: left;

  @media only screen and (max-width: ${screenSizes.tablet}) {
    padding: 0.25rem 0;
  }

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0;
  }

  h1 {
    color: #1a1a1a;
    font-size: 1.75rem;
    font-weight: 700;
    text-align: center;
    margin: 0 0 0.5rem;
    line-height: 1.3;
  }

  h2 {
    color: #1a1a1a;
    font-size: 1.35rem;
    font-weight: 700;
    text-align: center;
    margin: 0 0 1rem;
  }

  .intro {
    color: #555;
    font-size: 0.95rem;
    line-height: 1.6;
    text-align: center;
    margin: 0 0 1.75rem;
    max-width: 36rem;
    margin-left: auto;
    margin-right: auto;
  }

  .form-errors {
    color: #db2828;
    font-size: 0.9rem;
    text-align: center;
    margin: 0 0 1rem;
    padding: 0.65rem 1rem;
    background: #fff6f6;
    border-radius: 8px;
    border: 1px solid #e0b4b4;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 0.82rem;
      margin-bottom: 0.65rem;
      padding: 0.5rem 0.75rem;
    }
  }

  .ccf-form {
    max-width: 100%;
    margin-bottom: 0.5rem;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      gap: 0.65rem;
      margin-bottom: 0;
      padding: 0;

      .ui.input > input,
      .ui.selection.dropdown {
        min-height: 2.45rem !important;
      }

      .ccf-form__birthdate label {
        font-size: 0.82rem;
        margin-bottom: 0.25rem;
      }

      .ccf-form__birthdate .SingleDatePickerInput,
      .ccf-form__birthdate .DateInput_input {
        min-height: 2.45rem !important;
      }

      .ccf-form__birthdate-hint {
        font-size: 0.72rem;
        margin-top: 0.2rem;
        line-height: 1.35;
      }
    }
  }

  .form-section {
    margin-bottom: 1.5rem;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      margin-bottom: 0.9rem;
    }
  }

  .field-label {
    display: block;
    font-weight: 700;
    font-size: 0.8rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #1a1a1a;
    margin-bottom: 0.65rem;
    line-height: 1.4;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 0.72rem;
      margin-bottom: 0.4rem;
    }

    .required {
      color: #db2828;
    }
  }

  .form-field {
    margin-bottom: 1rem;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      margin-bottom: 0.5rem;
    }

    .ui.selection.dropdown,
    .ui.input {
      width: 100% !important;
      display: block !important;
      margin: 0 !important;
    }

    .ui.input > input {
      width: 100% !important;
      min-height: 2.75rem;
      box-sizing: border-box;
    }

    .ui.selection.dropdown.error,
    .ui.input.error > input {
      border-color: #e0b4b4 !important;
      background: #fff6f6 !important;
    }
  }

  .legal {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 14px;
    padding: 1rem 1.15rem;
    margin: 1.5rem 0;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      padding: 0.7rem 0.8rem;
      margin: 0.85rem 0;
      border-radius: 10px;
    }

    &.error {
      border-color: #e0b4b4;
      background: #fff6f6;
    }

    .legal-header {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;
    }

    .ui.checkbox label {
      font-weight: 700;
      font-size: 0.95rem;
      color: #1a1a1a;
      line-height: 1.4;

      &::before {
        border-radius: 4px;
      }
    }

    .legal-text {
      margin: 0.5rem 0 0 1.85rem;
      font-size: 0.82rem;
      line-height: 1.55;
      color: #666;

      @media only screen and (max-width: ${screenSizes.mobile}) {
        margin: 0.35rem 0 0 1.5rem;
        font-size: 0.74rem;
        line-height: 1.4;
      }

      a {
        color: #2185d0;
      }
    }
  }

  .submit-actions {
    text-align: center;
    padding-top: 0.5rem;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      padding-top: 0.25rem;
    }

    .ui.button.primary {
      width: 100%;
      max-width: 100%;
      font-size: 1rem;
      font-weight: 700;
      padding: 1rem 2rem;
      border-radius: 999px;
      background: #1a1a1a !important;
      color: #fff !important;

      @media only screen and (max-width: ${screenSizes.mobile}) {
        font-size: 0.92rem;
        padding: 0.85rem 1.5rem;
      }

      &:hover {
        background: #333 !important;
      }

      &:disabled {
        opacity: 0.6;
      }
    }
  }

  .success-view {
    text-align: center;
    padding: 1rem 0.5rem 0.5rem;
    width: 100%;
    box-sizing: border-box;
    overflow-wrap: break-word;

    h1 {
      margin: 0 0 1rem;
      font-size: clamp(1.2rem, 4.5vw, 1.75rem);
      line-height: 1.35;
      word-break: break-word;
    }

    p {
      color: #555;
      font-size: clamp(0.9rem, 3.2vw, 1rem);
      line-height: 1.6;
      margin: 0 0 1rem;
    }

    @media only screen and (max-width: ${screenSizes.mobile}) {
      padding: 0.75rem 0.25rem 0.5rem;

      h1 {
        font-size: 1.25rem;
      }

      p {
        font-size: 0.9rem;
      }
    }
  }
`;
